import { useEffect, useState } from "react";
import { useMapColorState } from "../../../store/MapColorState";
import { getZoomRange } from "../helper/MapUtil";
import useEffectSkipFirst from "../../../hooks/useEffectSkipFirst";
import WRAP from "WRAP-JS";

const CanvasMap = ({onReady}) => {
  const [view, setView] = useState(null);
  const {isGoogleMap, applyMapColor} = useMapColorState();
  const [hidden, setHidden] = useState(isGoogleMap);

  useEffect(() => {
    const mapDiv = document.getElementById('webgl-map');

    const zoomRange = getZoomRange();

    const view = WRAP.Geo.addWebGLMapView(mapDiv, {
      min_zoom: zoomRange.min_zoom,
      max_zoom: zoomRange.max_zoom,
      projection: 'Mercator'
    });

    if (!isGoogleMap) {
      WRAP.Geo.selectView(view);
      WRAP.Geo.switchMap(view);
      view.ready(() => {
        onReady();
      });
    }

    setView(view);

    // 初回render時のみ実行するので警告無視
    // eslint-disable-next-line
  },[]);

  useEffectSkipFirst(() => {
    if (!isGoogleMap) {
      WRAP.Geo.switchMap(view).then(() => {
        applyMapColor();
      });
    }
    setHidden(isGoogleMap);
  }, isGoogleMap);

  return (
    <div id='webgl-map' className="map" hidden={hidden}/>
  )
};

export default CanvasMap;
